import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import * as styles from './product-info-price-ds.styles'

export interface InlineSavingsProps {
  savingPercentage?: number
  perUnitSavingsPercentage: string
  showSavingPercentage: boolean
  showPerUnitSavingsPercentage: boolean
  updatedDesignForV2?: boolean
}

// Sale-price and per-unit savings rows inside the main column.
function InlineSavings({
  savingPercentage,
  perUnitSavingsPercentage,
  showSavingPercentage,
  showPerUnitSavingsPercentage,
  updatedDesignForV2,
}: InlineSavingsProps) {
  const { t } = useTranslation('common')
  return (
    <>
      {showSavingPercentage && (
        <div
          className={cx(
            styles.priceWrapperMainTextCss,
            styles.priceWrapperMainMarginCss,
            updatedDesignForV2 && styles.priceWrapperMainTextUpdatedDesignV2Css,
          )}
        >
          {t('you_save', { percentage: savingPercentage })}
        </div>
      )}

      {showPerUnitSavingsPercentage && (
        <div
          className={cx(
            styles.priceWrapperMainTextCss,
            updatedDesignForV2 && styles.priceWrapperMainTextUpdatedDesignV2Css,
          )}
        >
          {t('save')} <span>{perUnitSavingsPercentage}</span>
          {t('compared_to_traditional_retail')}
        </div>
      )}
    </>
  )
}

export default InlineSavings
